var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pinWindow",class:{
    fix: !_vm.selectionText,
  }},[_c('AppWindowHeader',{attrs:{"pinned":_vm.pinned},on:{"pin":_vm.pin,"close":_vm.onClose}}),_c('memo',{ref:"memo",attrs:{"memo":_vm.memo,"menu_thread_hidden":true,"backlink_hidden":true,"http_direct":_vm.http_direct,"isInPinWindow":true},on:{"tag-clicked":_vm.tagClicked,"memo-updated":_vm.updatedMemo,"share-clicked":_vm.shareClicked,"memo-editing":_vm.memoEditing}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }